import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from "@mui/lab";
import React from "react";
import IntroductionContainer from "./index.css";
import timelineData from "./timeline.data";

const TimelineContainer = () => {
  return (
    <IntroductionContainer.TimelineDiv>
      <Timeline position="alternate">
        {timelineData.map(data => (
          <TimelineItem id={data.title} key={data.id + data.content}>
            <TimelineOppositeContent color="text.secondary">
              {data.title}년
            </TimelineOppositeContent>

            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent>{data.content}</TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </IntroductionContainer.TimelineDiv>
  );
};

export default TimelineContainer;
